module.exports = __webpack_public_path__ + "media/images/talent/mv-slider12-36ea4a61f2bc1c357c732a4a503ce491.png";